export default "__VITE_ASSET__Dvqv2cKs__"